import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Error404 from '../../Page/Error404';
import DashboardPage from '../../Page/DashboardPage';
import ManageOrders from '../../Page/ManageOrders';
import ManagePayments from '../../Page/ManagePayments';
import ManageReports from '../../Page/ManageReports';
import Profile from '../../Page/Profile';
import AddRoom from '../../components/Rooms/AddRoom';
import ListAllAm from '../../components/Amenities/ListAllAm';
import Policies from '../../Page/Config/Policies';
import MediaLibrary from '../../Page/Config/MediaLibrary';
import ManageRooms from '../../Page/Manage/Rooms/ManageRooms';
import BookRoom from '../../Page/Manage/Rooms/BookRoom';
import BookRoomPage from '../../Page/Manage/Rooms/BookRoomPage';
import RoomHistory from '../../Page/RoomHistory';
import RoomHistoryPage from '../../Page/RoomHistoryPage';
import InHouseServices from '../../Page/Config/InHouseServices';
import ExpensePage from '../../Page/Expense/ExpensePage';
import ManageExpense from '../../Page/Expense/ManageExpense';
import ServiceReqPage from '../../Page/ServiceRequest/ServiceReqPage';
import OnlineBookingPage from '../../Page/OnlineBookingPage';
import BulkRoomBooking from '../../components/Rooms/book/BulkRoomBooking';
import UserAccess from '../../Page/UserAccess';
import OnlineBookRoom from '../../Page/Manage/Rooms/OnlineBookRoom';
import Settings from '../../Page/Manage/Settings';
import ListAllCust from '../../Page/Manage/Customer/ListAllCust';
import LoyaltyProg from '../../Page/Manage/Customer/LoyaltyProg';

import UserPermissionTab from '../../Page/UserPermissionTab';
import SeasonalPricePage from '../../Page/SeasonalPricePage';
import RoomType from '../../components/RoomType/RoomType';
import RoomByList from '../../components/SeaPrice/RoomByList';

const allRoutes = [
  { url: "", component: <DashboardPage /> },
  { url: "/dashboard", component: <DashboardPage /> },
  { url: "/manage-rooms", component: <ManageRooms /> },
  { url: "/book-room", component: <BookRoom /> },
  { url: "/manage-amenities", component: <ListAllAm /> },
  { url: "/add-room", component: <AddRoom /> },
  { url: "/edit-room", component: <AddRoom /> },
  { url: "/manage-orders", component: <ManageOrders /> },
  { url: "/manage-payments", component: <ManagePayments /> },
  { url: "/manage-report", component: <ManageReports /> },
  { url: "/profile", component: <Profile /> },
  { url: "/media-library", component: <MediaLibrary /> },
  { url: "/policies", component: <Policies /> },
  { url: "/book-room/action", component: <BookRoomPage /> },
  { url: "/book-room/online", component: <OnlineBookRoom /> },
  { url: "/room/history", component: <RoomHistory /> },
  { url: "/room-history", component: <RoomHistoryPage /> },

  { url: "/expense", component: <ExpensePage /> },
  { url: "/manage-expense", component: <ManageExpense /> },
  { url: "/service-requests", component: <ServiceReqPage /> },
  { url: "/in-house-services", component: <InHouseServices /> },
  { url: "/online-book", component: <OnlineBookingPage /> },
  { url: "/bulk-room-booking", component: <BulkRoomBooking /> },
  { url: "/user-access", component: <UserAccess /> },
  { url: "/user-permissions", component: <UserPermissionTab /> },

  { url: "/settings", component: <Settings /> },
  { url: "/customers", component: <ListAllCust /> },
  { url: "/loyalty", component: <LoyaltyProg /> },
  // { url: "/seasonal-princing-management", component: <SeasonalPricePage /> }, // // old one
  { url: "/seasonal-princing-management", component: <RoomByList /> },
  { url: "/manage-room-type", component: <RoomType /> },
];

const AppRoutes = () => {
  return (
    <Routes>
      {allRoutes.map((route, index) => (
        <Route
          key={index}
          path={route.url}
          element={route.component}
        />
      ))}

      <Route
        path="/"
        element={<Navigate to="/dashboard" replace />}
      />
      {/* Handle 404 */}
      <Route path="*" element={<Error404 />} />
    </Routes>
  );
};

export default AppRoutes;